function initInPageHalfPovalVideo() {
  const pageVideos = document.querySelectorAll('.half-poval-video-player');
  
  pageVideos.forEach(function (el, idx) {
    if (el.dataset.initialized === "true") return;

    console.log(el);
    // Page video scope variables
    const mask = el.querySelector('.half-poval-video-player__mask');
    const cursor = el.querySelector('.half-poval-video-player__cursor');
    const viewerContainer = el.querySelector('.in-page-video-player__viewer');

    // Ensure all required elements are present
    if (!mask || !cursor || !viewerContainer) return;

    const containerId = "hpvp-s7viewer-" + idx;
    viewerContainer.id = containerId;

    // Grab asset ID from data attribute
    const videoId = viewerContainer.getAttribute('data-video-id');
    if (!videoId) return;

    // Initialize Scene7 VideoViewer
    const viewer = new s7viewers.VideoViewer({
      containerId: containerId,
      params: {
        asset: videoId,
        config: 'bhsf/Video',
        serverurl: 'https://s7d9.scene7.com/is/image/',
        contenturl: 'https://s7d9.scene7.com/is/content/',
        videoserverurl: 'https://s7d9.scene7.com/is/content',
        autoplay: '0',
        loop: '0',
        mute: '1',
        controls: 'none'
      },
      handlers: {
        initComplete: function () {
          const s7container = viewerContainer.querySelector(".s7container");
          if (s7container) {
            s7container.removeAttribute("role");
          }

          const player = viewer.videoplayer;
          player.mute();

          // Expose player on element for later use
          viewerContainer.viewer = viewer;

          // Function to position the cursor relative to the mask element
          const positionCursor = (e) => {
            const { left, top } = mask.getBoundingClientRect();
            const x = e.clientX - left;
            const y = e.clientY - top;
            cursor.style.transform = `translate3d(${x - 62}px, ${y - 62}px, 0)`;
          };

          // Handle mouseenter events to play video and move cursor
          const handleMouseEnter = () => {
            mask.classList.add('focused');
            mask.classList.remove('unfocused');
            mask.addEventListener('mousemove', positionCursor);

            if (player) {
              player.play();
            }
          };

          // Handle mouseleave events to pause video and hide cursor
          const handleMouseLeave = () => {
            mask.classList.add('unfocused');
            mask.classList.remove('focused');
            mask.removeEventListener('mousemove', positionCursor);

            if (player) {
              player.pause();
            }
          };

          // Only attach event listeners if window width is greater than 900px
          const cursorPlayButton = () => {
            if (window.innerWidth > 900) {
              mask.addEventListener('mouseenter', handleMouseEnter);
              mask.addEventListener('mouseleave', handleMouseLeave);
            } else {
              mask.removeEventListener('mouseenter', handleMouseEnter);
              mask.removeEventListener('mouseleave', handleMouseLeave);
            }
          };

          // Initialize on page load and handle window resize
          cursorPlayButton();
          window.addEventListener('resize', cursorPlayButton);
        }
      }
    });

    viewer.init();
  });
}

document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelector(".half-poval-video-player")) {
    Scene7Loader.load(initInPageHalfPovalVideo);
  }
});